export default __webpack_public_path__ + "static/media/bg_master.5d626480.jpg";